import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import TransitionContainer from '../../components/Transition/TranstionContainer';

import VoteRegistrationStep6Form from '../../components/VoteRegistration/VoteRegistrationStep6Form';

import { PrefixList, SuffixList } from '../../utils/enums';

import { onGoToStep, saveForm } from './actions';
import { cacheFormData } from '../../utils/formCaching/actions';

import {
    ContainerStyled,
    LegalInfoWrapper,
    FormWrapper
} from '../DefaultStyles/AssessmentDetails';

import VoteRegistrationSidebar from '../../components/VoteRegistration/VoteRegistrationSidebar';

import LegalInfo from '../../components/Widget/LegalInfo';

const VoteRegistrationStep6 = props => (
    <TransitionContainer
        isSubmitting={props.isSubmitting}
        isBackTransition={props.isBackTransition}
        zIndex={30}
    >
        <ContainerStyled>
            <VoteRegistrationSidebar loadRep={true} title={'Voter Registration'} />
            <FormWrapper>
                <VoteRegistrationStep6Form
                    prefix={props.prefix}
                    suffix={props.suffix}
                    onBack={() => {
                        props.onGoToStep(5, 'back', null, null, [4, 5], props.formData);
                    }}
                    onSubmit={values => {
                        props.cacheFormData(values);
                        props.saveForm(values, [7], null, props.formData);
                    }}
                />
                {props.isMobileResolution && (
                    <LegalInfoWrapper>
                        <LegalInfo />
                    </LegalInfoWrapper>
                )}
            </FormWrapper>
        </ContainerStyled>
    </TransitionContainer>
);

VoteRegistrationStep6.propTypes = {
    onGoToStep: PropTypes.func.isRequired,
    saveForm: PropTypes.func.isRequired,
    prefix: PropTypes.array.isRequired,
    suffix: PropTypes.array.isRequired,
    formData: PropTypes.object,
    isSubmitting: PropTypes.bool,
    isBackTransition: PropTypes.bool,
    isMobileResolution: PropTypes.bool,
    cacheFormData: PropTypes.func.isRequired
};

export default connect(
    state => ({
        prefix: PrefixList,
        suffix: SuffixList,
        formData: state.voteRegistration.formData,
        isSubmitting: state.voteRegistration.isSubmitting,
        isBackTransition: state.voteRegistration.isBackTransition,
        isMobileResolution: state.widget.isMobileResolution
    }),
    { onGoToStep, saveForm, cacheFormData }
)(VoteRegistrationStep6);



// WEBPACK FOOTER //
// ./src/containers/VoteRegistration/VoteRegistrationStep6.jsx